<div class="modal-header">
  <h2 class="modal-title">{{title | translate}}</h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="buttonClicked(false)">
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      {{description | translate}}
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn link-btn" (click)="buttonClicked(false)">
    <i class="app-icon icon icon-return icon-lg me-2"></i> 
    {{cancelButton | translate}}
  </button>
  <button type="button" class="btn primary-btn" (click)="buttonClicked(true)">
    {{successButton | translate}}
  </button>
</div>

